// Copyright (c) 2026 by Audere

import { createTheme } from "@mui/material";

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    errorBody: true;
  }
}

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    md: false;
    xl: false;
    desktop: true;
  }
}

const initTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      lg: 1200,
      desktop: 1360,
    },
  },
});

export const theme = createTheme(initTheme, {
  typography: {
    errorBody: {
      ...initTheme.typography.subtitle1,
      color: initTheme.palette.error.main,
    },
  },
});
